export { PluginSingleTab } from './PluginSingleTab.component';
